var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[(_vm.getLoading)?_c('v-progress-linear',{staticClass:"progress_bar",attrs:{"indeterminate":""}}):_vm._e(),_c('TemplateDefault')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }